import { createSlice } from '@reduxjs/toolkit';

const initialState = { messages: [] };

export const MessagesSlice = createSlice({
  name: 'messages',
  initialState,
  reducers: {
    addMessage: (state, { payload }) => {
      state.messages.push(payload);
    },
    removeMessage: (state, { payload }) => {
      state.messages = state.messages.filter((x) => x.id != payload);
    },
    clearMessages: (state) => {
      state.messages = [];
    },
  },
});

export const { addMessage, removeMessage, clearMessages } = MessagesSlice.actions;

export default MessagesSlice.reducer;
